import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { CheckboxListBox } from "./checkboxListBox";
import { ModalOptionForm } from "./modalOptionForm";
import { PullDownOptionForm } from "./pullDownOptionForm";
import { Image } from "../atoms/image";
import { Label } from "../atoms/label";
import img_arw from '../../resources/icons/arw-1.svg';
import { golfFacility } from "../../const";
import common from "../../resources/js/common/common";

const ConditionDesignationArea = (props) => {
    const { 
        playDate1,
        group,
        course,
        detailCondition,
        startTime,
        setGroup,
        kaiinken,
        setKaiinken,
        style,
        isMobilePhone,
        onClickOpenSelectDateWindow,
        onClickOpenStartTimeWindow,
        onClickOpenSelectAreaWindow,
        setCourse,
        displaySwitch } = props;

    const [isOpen, setIsOpen] = useState(false);
    const [groupNumber, setGroupNumber] = useState("1");
    const [kaiinkenNumber, setKaiinkenNumber] = useState("1");




    // プレー日表示処理
    const getDateToString = () => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const playDate = new Date(playDate1);
        const m = playDate.getMonth() + 1;
        const d = playDate.getDate();

        return `${m}月${d}日(${youbi[playDate.getDay()]})`;
    }

    // スタート時間表示処理
    const getStartTimeToString = () => {
        let textValue = "";
        let onCheckFlg = false;
        for (var i in startTime) {
            if (startTime[i].checked === true) {
                textValue = textValue + (textValue == "" ? "" : ", ");
                textValue = textValue + startTime[i].value;
                onCheckFlg = true;
            }
        }
        return (onCheckFlg ? textValue : "選択なし");
    }

    const getCourseName = () => {
        const array = course.filter((data) => {
            return data.checked === true;
        });

        if (array.length === 0) {
            return "選択なし";
        }

        if (array.length === course.length) {
            return "すべて";
        } else {
            const text = array.map((data) => {
                return data.value;
            });
            return text.join(", ");
        }
    }

    const onChangeKaiinkenName = (e) => {
        setKaiinkenNumber(e.target.value);
        kaiinken.forEach((data) => {
            if (String(data.id) === e.target.value) {
                data.selected = true;
                common.doPost(golfFacility, {kaiinKind:data.kaiinkenSyubetCd,sisetuCd:data.sisetuCd}, afterGetFacility);
            } else {
                data.selected = false;
            }
        })
        setKaiinken(kaiinken);
    }

    // 施設取得後処理
    const afterGetFacility = (res) => {
        const data = res.data.map((item) => {
            return {
                id: item.courseid,
                facilityCd: item.facility_cd,
                value: item.facility_name,
                category: item.hotel_category_name,
                class: "area_course",
                checked: true,
                zip: item.zip,
                address: item.address,
                access_car: item.access_car,
                facility_overview_title: item.facility_overview_title,
                facility_overview_detail: item.facility_overview_detail,
                url: item.url,
                image_path: item.image_path,
                memberShipAuth: item.memberShipAuth,
                sortNum:parseInt(item.inside_category_sort),
            };
        });
        //表示施設のソート処理
        data.sort(function(first,second){
            if (first.sortNum > second.sortNum){
                return 1;
            }else if (first.sortNum < second.sortNum){
                return -1;
            }else{
                return 0;
            }
        })

        setCourse(data);
    }

    const onClickOpenArea = () => {
        setIsOpen(!isOpen);
    };

    // 選択した組数をstoreに保存
    const onChangeGroup = (e) => {
        setGroupNumber(e.target.value);

        group.forEach((data) => {
            if (data.id === e.target.value) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setGroup(group);
    };

    return (
        <>
            <div style={style.container}>
                <ModalOptionForm
                    id={"playDate"}
                    divClass={isMobilePhone ? "wrapMobile" : "wrap"}
                    title={"プレー日"}
                    onClick={onClickOpenSelectDateWindow}
                    text={getDateToString()} />
                <ModalOptionForm
                    divClass={isMobilePhone ? "wrapMobile" : "wrap"}
                    title={"スタート時間"}
                    onClick={onClickOpenStartTimeWindow}
                    text={getStartTimeToString()} />
                    <PullDownOptionForm
                    divClass={isMobilePhone ? "wrapMobile" : "wrap"}
                    title={"会員権選択"}
                    selectClass={"pullDownOptionKaiinkenStyle"}
                    data={kaiinken}
                    state={kaiinkenNumber}
                    onChange={onChangeKaiinkenName} />
                <PullDownOptionForm
                    divClass={isMobilePhone ? "wrapMobile" : "wrap"}
                    title={"組数"}
                    selectClass={"pullDownOptionStyle"}
                    data={group}
                    state={groupNumber}
                    onChange={onChangeGroup} />
                <ModalOptionForm
                    divClass={isMobilePhone ? "wrapMobile" : "wrap"}
                    title={"ゴルフ場"}
                    onClick={onClickOpenSelectAreaWindow}
                    text={getCourseName()} />
                {props.noDisplay === true ?
                    null
                    :
                    <div style={style.detailedConditionContainer}>
                        <div style={style.detailsButton} onClick={onClickOpenArea}>
                            <Label label="詳細条件" style={style.detailLabel} />
                            <div style={style.detailImage} >
                                <Image image={img_arw} style={isOpen ? style.arwTop : style.arwBtm} />
                            </div>
                        </div>
                        <div style={isOpen ? style.detailedConditionArea : { display: "none" }}>
                            <CheckboxListBox divStyle={isMobilePhone ? style.divStyleMobile : style.divStyle}
                                labelAreaStyle={style.labelAreaStyle}
                                title={"プレイスタイル"}
                                data={detailCondition}
                                checkAreaStyle={isMobilePhone ? style.playStyleCheckAreaMobile:style.playStyleCheckArea} />
                        </div>
                    </div>
                }
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        playDate1: state.playDate1,
        group: state.group,
        course: state.course,
        detailCondition: state.detailCondition,
        startTime: state.startTime,
        kaiinken:state.kaiinken
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setGroup: (item) => {
            dispatch({ type: "GROUP", payload: { group: item } })
        },
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: {kaiinken:item} })
        }
    };
}

const style = {
    detailedConditionContainer: {
        backGroundColor: "#f0f0f0",
    },
}
export default connect(mapStateToProps, mapDispatchToProps)(ConditionDesignationArea);